<template>
  <div>
    <b-container ref="container" class="p-0 m-0 multiselect-root" tabindex="0" fluid @focusout="focusOut">
      <b-row class="p-0 m-0 multiselect-row" align-v="center" @click="showList = (!showList && !readOnly)">
        <b-col class="pl-0 m-0 text-left align-middle">
          <b-container fluid class="no-gutters p-0 m-0">
            <b-row class="no-gutters p-0 m-0">
              <b-col cols="auto"
                     :style="{backgroundColor: item.isActive ? '#C6D8F8' : '#DBE8FF', color: 'black',}"
                     :class="'d-flex align-items-center ml-1 pl-3 m-0 text-left align-middle text-pills-pill rounded-lg rounded-pill ' + (readOnly ? 'pr-3' : 'pr-2')"
                     variant="light"  v-for="item in selectedItems" :key="item.value" @click="changeFilter(item)">
                <span style="user-select: none;">{{ item.text }}</span>
                <b-btn  v-if="!readOnly" variant="plm-toolbar" style="" class="text-pills-remove-btn border-0"  @mousedown.stop="" @click.stop="removeItem(item)">×</b-btn>
              </b-col>
              <span class="ml-2" style="cursor: pointer" v-if="selectedItems.length > 0" @click="removeAll">{{$tr("clearAll", "Clear All")}}</span>
            </b-row>
          </b-container>
        </b-col>
        <b-col cols="auto" class="p-0 m-0"  v-if="!readOnly && allowAdd" >
          <span class="select-arrow" tabindex="0" @click="focusOnHead" @keydown="arrowKeyDown"></span>
        </b-col>
      </b-row>

      <b-row style="position: relative; width: 100%; height: 0px;" class="pl-0 m-0">
        <div style="position: absolute; z-index: 10000; top:4px; width: calc(100% - 2px); padding-left: 2px;" v-if=" showList && allowAdd">

          <div v-if="allItems.length == 0" class="list-group">
            <span class="list-group-item list-group-item-action"> <i> {{ $tr("NoItems","No items") }} </i></span>
          </div>

          <div v-else class="multiselect-items d-flex flex-column">
            <div v-if="showSearch" class="list-group-item d-flex w-100 ">
              <div class="d-flex pt-1 pb-2" style="line-height: unset">
                <div style="width: 0px">
                  <span :class="statusColor" style="position: relative; left: 15px; top:6px" >
                      <font-awesome-icon :icon="['fa', 'search']" />
                  </span>
                </div>
                <b-form-input class="mr-1 ml-1 multiselect-search"
                              autocomplete="off"
                              style="padding-left: 32px"
                              placeholder=""
                              v-model="searchInput"
                              @keypress="searchChanged"
                              @keydown="onKeyUp"
                              @focusout="searchFocusout"
                              ref="query"
                ></b-form-input>

                <div style="width: 0px" >
                    <span style="position: relative; left: -32px; top:4px" >
                      <a href="#" @click="clearClicked" ref="clearLink" :class="statusColor" style="position: relative; top:1px"  v-if="!(lastQuery!==searchInput || searchInput === '')">
                          <font-awesome-icon :icon="['fa', 'times']" class="fa-lg pt-1 pr-2"/>
                      </a>
                    </span>
                </div>
              </div>

              <b-col cols="auto" class="pt-1 pl-1 pr-1">
                <b-btn variant="plm-toolbar-secondary" @click="selectAll">
                  <font-awesome-layers >
                    <font-awesome-icon :icon="['fas', 'check']" transform="up-4 shrink-3" />
                    <font-awesome-icon :icon="['fas', 'check']" transform="down-4 shrink-3" />
                  </font-awesome-layers>
                </b-btn>
              </b-col>
              <b-col cols="auto" class="pt-1 pl-0">
                <b-btn variant="plm-toolbar-secondary" @click="unselectAll">
                  <font-awesome-layers >
                    <font-awesome-icon :icon="['far', 'square']" transform="up-6 shrink-4" />
                    <font-awesome-icon :icon="['far', 'square']" transform="down-6 shrink-4" />
                  </font-awesome-layers>
                </b-btn>
              </b-col>

            </div>
            <!--boostrap border-bottom-->
            <div class="list-group" style="max-height: 200px; overflow: auto;">
              <div v-for="item in filteredItems" :key="item.value"  class="list-group-item list-group-item-action d-flex w-100 mb-0">
                <b-form-checkbox :id="item.__id" v-model="item.__selected" @change="updateItem(item)" :data-value="item.value"></b-form-checkbox>
                <label :for="item.__id" class=" mb-0"> {{ item.text }}</label>
              </div>
            </div>
          </div>

        </div>
      </b-row>

    </b-container>
  </div>
</template>

<script>

import DialogManager from "@/utils/DialogManager";
import filterRenderers from "@/components/forms/renderers/FilterRenderers";
import DelayedExecution from "@/utils/DelayedExecution";

let ctr = 0;
export default {
  name: "Multiselect",
  mounted() {
    for(let el of this.selected){
      if(el.value !== undefined){
        this.localSelectedValues.add(el.value);
      }
      else{
        this.localSelectedValues.add(el);
      }
    }
    this.updateAllItems();
  },

  created() {
    this.refreshDelayedScheduler = new DelayedExecution(() => {
      this.refresh();
    });
  },

  methods: {
    async changeFilter(item){
      if(this.form) {
        this.clicks++;
        if (this.clicks === 1) {
          this.timer = setTimeout(async () => {
            item.isActive = !item.isActive;
            setTimeout(function () {
              item.isActive = false;
            }, 10000);
            this.clicks = 0
          }, this.delay);
        } else {
          this.clicks = 0;
          item.isActive = false;
          clearTimeout(this.timer);
          this.$emit('setup-filters');
          let col = null
          let result = [];
          let colTable = [];
          let options = this.eligibleFields.map(value => ({text: value.fieldLabel, value}));
          for (let option of options) {
            if (option.text == item.text) {
              col = option.value;
            }
          }
          let selectedFilter = null;
          this.activeFilters.forEach(activeFilter => {
            if (activeFilter.fieldName === col.fieldName) {
              selectedFilter = activeFilter;
            }
          })
          const resultToPush = await filterRenderers[col.filterRenderer](col, this.form, this.context, this, selectedFilter);
          if (resultToPush && !Array.isArray(resultToPush) || resultToPush && resultToPush.some(item => item !== null)) {
            result.push(resultToPush);
            colTable.push(col);

            if (!result) {
              this.refreshDelayedScheduler.resumeExecution();
              return;
            }
            this.$emit("change-filter", colTable, result)
          }
        }
      }
    },
    removeAll(){
      for(let item of this.selectedItems) {
        this.removeItem(item);
      }
      this.$emit("filters-clear")
    },

    removeItem(val){
      val.__selected = false;
      this.localSelectedValues.delete(val.value);
      this.updateSelectedItems();
      this.$refs["container"].focus();
      this.$emit("item-removed", val)
      this.$emit('closeModal')
    },

    selectAll(){
      this.allItems.forEach(i => {
        i.__selected = true;
        this.localSelectedValues.add(i.value);
      });
      this.updateSelectedItems();
      this.$emit('model-change', [...this.selectedItems]);
    },
    unselectAll(){
      this.allItems.forEach(i => {
        i.__selected = false;
        this.localSelectedValues.delete(i.value);
        this.$emit("item-removed", i.value);
      });
      this.updateSelectedItems();
      this.$emit('model-change', [...this.selectedItems]);
    },

    searchChanged(key){
      if (key == "Enter") {
        this.searchClicked();
        return false;
      }
      if (key == "Escape") {
        this.clearClicked();
        return false;
      }

      if (this.pendingTimer) {
        clearTimeout(this.pendingTimer);
        this.pendingTimer = null;
      }

      this.pendingTimer = setTimeout(() => {
        this.executeQuery();
        clearTimeout(this.pendingTimer);
        this.pendingTimer = null;
      }, 1000);
    },
    onKeyUp(ev){
      let key = ev.keyCode || ev.charCode;

      if( key == 8 || key == 46 ) {
        this.searchChanged("Backspace");
      }
      if( key == 27 ) {
        this.searchChanged("Escape");
      }
      if( key == 13 ) {
        this.searchChanged("Enter");
      }
      if( key == 46 ) {
        this.searchChanged("Del");
      }
    },
    searchFocusout(){
    },

    searchClicked(){
      clearTimeout(this.pendingTimer);
      this.pendingTimer = null;
      this.executeQuery();
      this.$refs["query"].focus();
    },
    clearClicked(){
      clearTimeout(this.pendingTimer);
      this.pendingTimer = null;
      this.searchInput = "";
      this.executeQuery();
      this.$refs["query"].focus();
    },

    executeQuery(){
      // console.log("Filter" + this.searchInput);
      if(!this.searchInput){
        this.statusColor = "text-secondary";
      } else {
        this.statusColor = "text-success";
      }
      this.lastQuery = this.searchInput;
      this.updateAllItems();
    },
    /**
     * @param {FocusEvent} event
     */
    focusOut(event){
      if(event.relatedTarget && this.$el.contains(event.relatedTarget)){
        return false;
      }
      this.showList = false;
    },
    /**
     * @param {KeyboardEvent} ev
     */
    arrowKeyDown(ev){
      if(ev.code == "Space"){
        this.showList = !this.showList && !readOnly;
      }
    },
    focusOnHead(){
      this.$refs["container"].focus();
    },

    updateItem(item){
      if(item.__selected){
        this.localSelectedValues.add(item.value);
      } else {
        this.localSelectedValues.delete(item.value);
      }

      this.updateSelectedItems();
      this.$emit('model-change', [...this.selectedItems]);
    },

    updateSelectedItems(){
      let newSelectedItems = [];
      for(let it of this.allItems){
        if(this.localSelectedValues.has(it.value)) {
          newSelectedItems.push(it);
        }
      }
      this.selectedItems = newSelectedItems;
    },

    updateAllItems(){
      let allItems = [];
      let filteredItems = [];
      for(let it of this.items){
        // console.log(it)
        let item = null;

        if(typeof it.fieldLabel === 'string' || it.fieldLabel instanceof String){
          item = {value:it.fieldLabel, text:it.fieldLabel, records:it.records, isActive:false};
        } else {
          item = {...it};
        }

        item.__selected = this.localSelectedValues.has(item.value)
        item.__id = Math.random() + "-" + ctr++;
        if(this.searchInput){
          if(item.text && item.text.toLowerCase().includes(this.searchInput.toLowerCase())) {
            item.__show = true;
            filteredItems.push(item);
          } else {
            item.__show = false;
          }
        } else {
          item.__show = true;
          filteredItems.push(item);
        }
        allItems.push(item);
      }
      this.allItems = allItems;
      this.filteredItems = filteredItems;
      this.updateSelectedItems();
    }
  },
  computed: {
    showSearch:function(){
      return (this.items && this.items.length > 10 && this.searchBar === null) || this.searchBar;
    }
  },
  watch: {
    selected: {
      handler: function(){
        let values = new Set();
        if(this.selected){
          for(let el of this.selected){
            if(el.value !== undefined){
              values.add(el.value);
            }
            else{
              values.add(el);
            }
          }
        }
        this.localSelectedValues = new Set(values);
        this.updateAllItems();
      }
    },
    items:{
      handler: function() {
        this.updateAllItems();
      }
    }
  },
  props:{
    searchBar: {type: Boolean, default:null},
    readOnly: { type: Boolean, default:false},
    items: { type: Array, default:[]},
    context:{default: null},
    recordsWithChosenFiltersInStreamingMode: {default: null},
    form:{default: null},
    records:{default: null},
    permissions:{default: null},
    eligibleFields:{default: null},
    selected: { type: Array, default:[]},
    template: { type: Object, default: null},
    allowAdd: {type: Boolean, default: true},
    activeFilters: {default: null}
  },
  model: {
    prop: 'selected',
    event: 'model-change'
  },

  data: ()=>{ return {
    showList: false,
    localItems:[],
    localSelectedValues: new Set(),
    selectedItems:[],
    allItems:[],
    filteredItems:[],
    version:0,
    statusColor:"text-secondary",
    searchInput:"",
    lastQuery:"",

    delay: 200,
    clicks: 0,
    timer: null,
  }
  }
}
</script>
